import components from '../components';

export default {
    el: '.wrap',
    components: components,
    directives: {},
    mixins: [],
    options: {},
    plugins: [],
};
